// utils/websocket.js
export default function createWebSocket (url, options = {}) {
  const maxReconnectCount = options.maxReconnectCount || 5
  const reconnectInterval = options.reconnectInterval || 3000
  const heartbeatInterval = options.heartbeatInterval || 30000
  const heartbeatMsg = options.heartbeatMsg || 'ping'

  let ws
  let reconnectTimer
  let heartbeatTimer
  let reconnectCount = 0
  let eventCallbacks = {
    open: [],
    message: [],
    close: [],
    error: []
  }

  // 创建连接
  function connect () {
    try {
      ws = new WebSocket(url)
      setupEventListeners()
      // console.log('[WebSocket] 正在连接...')
    } catch (error) {
      // console.error('[WebSocket] 创建连接失败:', error)
      scheduleReconnect()
    }
  }

  // 设置事件监听
  function setupEventListeners () {
    ws.onopen = () => {
      // console.log('[WebSocket] 连接成功')
      reconnectCount = 0
      startHeartbeat()
      triggerEvent('open')
    }

    ws.onmessage = (event) => {
      // console.log('[WebSocket] 收到消息:', event.data)
      try {
        const data = JSON.parse(event.data)
        triggerEvent('message', data)
      } catch (error) {
        triggerEvent('message', event.data)
      }
    }

    ws.onclose = (event) => {
      // console.log(`[WebSocket] 连接关闭，状态码: ${event.code}`)
      clearInterval(heartbeatTimer)
      triggerEvent('close', event)
      scheduleReconnect()
    }

    ws.onerror = (error) => {
      // console.error('[WebSocket] 发生错误:', error)
      triggerEvent('error', error)
    }
  }

  // 定时重连
  function scheduleReconnect () {
    if (reconnectCount < maxReconnectCount) {
      clearTimeout(reconnectTimer)
      reconnectCount++
      const delay = reconnectInterval * reconnectCount
      // console.log(`[WebSocket] 将在 ${delay / 1000}s 后尝试重连 (${reconnectCount}/${maxReconnectCount})`)
      reconnectTimer = setTimeout(connect, delay)
    } else {
      // console.error('[WebSocket] 达到最大重连次数，停止重连')
    }
  }

  // 启动心跳
  function startHeartbeat () {
    clearInterval(heartbeatTimer)
    heartbeatTimer = setInterval(() => {
      if (ws && ws.readyState === WebSocket.OPEN) {
        // console.log('[WebSocket] 发送心跳')
        ws.send(heartbeatMsg)
      }
    }, heartbeatInterval)
  }

  // 发送消息
  function send (message) {
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(typeof message === 'string' ? message : JSON.stringify(message))
    } else {
      // console.error('[WebSocket] 连接未建立，无法发送消息')
    }
  }

  // 关闭连接
  function close (code = 1000, reason = '正常关闭') {
    clearInterval(heartbeatTimer)
    clearTimeout(reconnectTimer)
    if (ws && ws.readyState !== WebSocket.CLOSED) {
      ws.close(code, reason)
    }
  }

  // 监听事件
  function on (event, callback) {
    if (eventCallbacks[event]) {
      eventCallbacks[event].push(callback)
    }
    return this
  }

  // 触发事件
  function triggerEvent (event, data) {
    if (eventCallbacks[event]) {
      eventCallbacks[event].forEach(callback => callback(data))
    }
  }

  // 初始化连接
  connect()

  return {
    send,
    close,
    on
  }
}



// WEBPACK FOOTER //
// ./src/utils/websocket.js